import PurchasedCars from "./PurchasedCars";

export default PurchasedCars;